/* eslint-disable tsdoc/syntax */
import { SVGProps } from "react";
export const GreenCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 437 387"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_f_56501_136292)">
      <rect
        x="124"
        y="124"
        width="188.805"
        height="138.559"
        rx="69.111"
        fill="#19D13B"
        fill-opacity="0.07"
      />
    </g>
    <g clip-path="url(#clip0_56501_136292)">
      <circle
        cx="218.073"
        cy="208.429"
        r="23.6399"
        fill="#6EBD7F"
        fill-opacity="0.14"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M221.887 180.219C208.426 180.219 197.484 191.16 197.484 204.621C197.484 218.082 208.426 229.024 221.887 229.024C235.348 229.024 246.289 218.082 246.289 204.621C246.289 191.16 235.348 180.219 221.887 180.219ZM201.115 204.621C201.115 193.169 210.434 183.85 221.887 183.85C233.339 183.85 242.658 193.169 242.658 204.621C242.658 216.074 233.339 225.393 221.887 225.393C210.434 225.393 201.115 216.074 201.115 204.621Z"
        fill="#6EBD7F"
      />
      <path
        d="M232.77 196.924C232.067 196.221 230.906 196.221 230.204 196.924L218.68 208.447L213.571 203.338C212.868 202.636 211.707 202.636 211.005 203.338C210.302 204.041 210.302 205.202 211.005 205.904L217.397 212.296C217.736 212.635 218.196 212.829 218.68 212.829C219.164 212.829 219.624 212.635 219.963 212.296L232.77 199.489C233.472 198.787 233.472 197.626 232.77 196.924Z"
        fill="#6EBD7F"
      />
      <path
        d="M187.981 179.315C189.099 179.366 189.937 180.278 189.89 181.32C189.842 182.362 188.924 183.194 187.806 183.143C186.689 183.092 185.851 182.18 185.899 181.138C185.946 180.096 186.863 179.264 187.981 179.315Z"
        stroke="#C9D0D6"
        stroke-width="1.01075"
      />
      <circle
        cx="254.676"
        cy="179.454"
        r="3.05031"
        stroke="#5656CA"
        stroke-width="1.52515"
      />
      <path
        d="M237.39 166.032C237.599 165.545 237.313 165.014 236.753 164.845C236.192 164.677 235.568 164.935 235.36 165.421L236.375 165.727L237.39 166.032ZM233.072 170.759C232.863 171.246 233.149 171.777 233.71 171.946C234.27 172.114 234.894 171.857 235.103 171.37L234.087 171.065L233.072 170.759ZM236.375 165.727L235.36 165.421L233.072 170.759L234.087 171.065L235.103 171.37L237.39 166.032L236.375 165.727Z"
        fill="#F16613"
      />
      <path
        d="M209.204 164.865C209.082 164.343 208.516 163.963 207.939 164.016C207.362 164.069 206.993 164.535 207.115 165.057L208.16 164.961L209.204 164.865ZM208.921 172.782C209.043 173.304 209.61 173.684 210.187 173.631C210.764 173.579 211.133 173.113 211.011 172.59L209.966 172.686L208.921 172.782ZM208.16 164.961L207.115 165.057L208.921 172.782L209.966 172.686L211.011 172.59L209.204 164.865L208.16 164.961Z"
        fill="#FBCE68"
      />
      <path
        d="M260.328 210.156L260.328 216.669"
        stroke="#C9D0D6"
        stroke-width="1.34626"
        stroke-linecap="round"
      />
      <path
        d="M263.695 213.414L256.964 213.414"
        stroke="#C9D0D6"
        stroke-width="1.34626"
        stroke-linecap="round"
      />
      <path
        d="M1207.9 -2358.4C1207.9 -2362.22 1204.85 -2365.27 1201.04 -2365.27C1197.22 -2365.27 1194.17 -2362.22 1194.17 -2358.4C1194.17 -2354.59 1197.22 -2351.54 1201.04 -2351.54C1204.85 -2351.54 1207.9 -2354.59 1207.9 -2358.4Z"
        fill="white"
      />
      <path
        d="M1201.04 -2351.54C1204.85 -2351.54 1207.9 -2354.59 1207.9 -2358.4C1207.9 -2362.22 1204.85 -2365.27 1201.04 -2365.27C1197.22 -2365.27 1194.17 -2362.22 1194.17 -2358.4C1194.17 -2354.59 1197.22 -2351.54 1201.04 -2351.54ZM1201.04 -2351.54L1201.04 -1637.01L1201.04 -206.411C1201.04 -189.565 1187.38 -175.908 1170.53 -175.908L-1573.22 -175.909C-1590.06 -175.909 -1603.72 -162.252 -1603.72 -145.405L-1603.72 521.849"
        stroke="#6EBD7F"
        stroke-width="4.57546"
      />
      <path
        d="M183.891 224.445L183.891 230.608"
        stroke="#F16613"
        stroke-width="1.52515"
        stroke-linecap="round"
      />
      <path
        d="M187.074 227.523L180.706 227.523"
        stroke="#F16613"
        stroke-width="1.52515"
        stroke-linecap="round"
      />
      <circle
        cx="252.656"
        cy="237.066"
        r="2.59276"
        stroke="#F0B02A"
        stroke-width="0.915092"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_56501_136292"
        x="0"
        y="0"
        width="436.805"
        height="386.562"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="62"
          result="effect1_foregroundBlur_56501_136292"
        />
      </filter>
      <clipPath id="clip0_56501_136292">
        <rect
          width="108"
          height="102"
          fill="white"
          transform="translate(166.195 147)"
        />
      </clipPath>
    </defs>
  </svg>
);
